export const postHeight = () => {
  var height = document.body.scrollHeight;
  window.parent.postMessage({ iframeHeight: height }, "*");
};

export const postLoading = (isLoading) => {
  window.parent.postMessage({ iframeLoading: isLoading }, "*");
};

export const postOpenModal = (message) => {
  message.type = "snippet-to-overlay";
  window.parent.postMessage(message, "*");
};

export const postProgressData = (percentage, currentMessage) => {
  const message = {
    type: "snippet-to-overlay",
    childrenType: "save-progress",
    currentPercentage: percentage,
    currentMessage: currentMessage,
  };
  window.parent.postMessage(message, "*");
}

export const postSubmitStatus = (status) => {
  window.parent.postMessage({ submit: status }, "*");
};

export const postClose = (status) => {
  const closeRequest = {
    action: "close",
    status: status,
  };
  window.parent.postMessage(closeRequest, "*");
}